import DomainException from '~/modules/Exceptions/Domain/DomainException'
import { TrophyMemory } from '~/modules/TrophyMemories/Domain/TrophyMemory'

export default class TrophyMemoryDomainException extends DomainException {
  public static mediaNotSupportedId = 'trophy_memory_media_not_supported'
  public static unsupportedFileExtensionId = 'trophy_memory_unsupported_file_extension'

  public static notSupported (media: string): TrophyMemoryDomainException {
    return new TrophyMemoryDomainException(`Media ${media} is not supported`, this.mediaNotSupportedId)
  }

  public static unsupportedFileExtension (
    fileExtension: string,
    type: TrophyMemory['type']
  ): TrophyMemoryDomainException {
    return new TrophyMemoryDomainException(
      `Extension ${fileExtension} is not supported for ${type} media type`,
      this.unsupportedFileExtensionId
    )
  }
}
